import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '../data/mock';

const Logo = () => (
  <Link to="/" className="flex items-center gap-1 select-none">
    <span className="font-extrabold text-2xl tracking-tight" style={{ color: '#F39200' }}>easy</span>
    <span className="font-extrabold text-2xl tracking-tight text-neutral-900">works</span>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const isActive = (href) => loc.pathname === href;
  return (
    <header className="sticky top-0 z-50 bg-[#FAF2E8]/90 backdrop-blur-md border-b border-black/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <Link
              key={l.label}
              to={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={`text-[15px] transition-colors ${isActive(l.href) ? 'text-[#F39200] font-semibold' : 'text-neutral-800 hover:text-[#F39200]'}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <button className="lg:hidden text-neutral-900" onClick={() => setOpen(!open)} aria-label="menu" data-testid="mobile-menu-toggle">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#FAF2E8] border-t border-black/5 px-5 py-4 flex flex-col gap-3">
          {navLinks.map((l) => (
            <Link
              key={l.label}
              to={l.href}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={`text-[15px] ${isActive(l.href) ? 'text-[#F39200] font-semibold' : 'text-neutral-800'}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
